// src/theme.js
import { createTheme } from '@mui/material/styles';

export const DOMAIN_COLORS = [
    {
        "key": "color_primary",
        "label": "Primärfarbe",
        "defaultValue": "#f29216"
    },
    {
        "key": "color_primary_light",
        "label": "Primärfarbe hell",
        "defaultValue": "#f7b147"
    },
    {
        "key": "color_primary_dark",
        "label": "Primärfarbe dunkel",
        "defaultValue": "#b66200"
    },
    {
        "key": "color_primary_contrast",
        "label": "Text auf Primärfarbe",
        "defaultValue": "#ffffff"
    },
    {
        "key": "color_secondary",
        "label": "Sekundärfarbe",
        "defaultValue": "#00cc98"
    },
    {
        "key": "color_background",
        "label": "Seitenhintergrund",
        "defaultValue": "#f7f9fc"
    },
    {
        "key": "color_paper",
        "label": "Flächen",
        "defaultValue": "#ffffff"
    },
    {
        "key": "color_text",
        "label": "Textfarbe",
        "defaultValue": "#111827"
    },
    {
        "key": "color_text_secondary",
        "label": "Sekundäre Textfarbe",
        "defaultValue": "#6b7280"
    },
    {
        "key": "color_footer_background",
        "label": "Footer-Hintergrund",
        "defaultValue": "#101d2a"
    },
    {
        "key": "color_footer_text",
        "label": "Footer-Text",
        "defaultValue": "#f5f7fb"
    }
];

export function getDomainColors(config = {}) {
    return Object.fromEntries(DOMAIN_COLORS.map(({ key, defaultValue }) => [
        key, /^#[0-9a-f]{6}$/i.test(config[key] || '') ? config[key] : defaultValue,
    ]));
}

export function createDomainTheme(config = {}) {
    const colors = getDomainColors(config);
    return createTheme({
    palette: {
        primary: {
            main: colors.color_primary,
            light: colors.color_primary_light,
            dark: colors.color_primary_dark,
            contrastText: colors.color_primary_contrast,
        },
        secondary: {
            main: colors.color_secondary,
        },
        text: { primary: colors.color_text, secondary: colors.color_text_secondary },
        background: {
            default: colors.color_background,
            paper: colors.color_paper,
        },
    },
    typography: {
        h1: {
            fontSize: "2.5rem",
            fontWeight: 700,
            color: colors.color_primary,
            textAlign: "center",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        },
        h2: { fontWeight: 700, letterSpacing: '-0.01em' },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: { boxShadow: '0 8px 24px rgba(2,14,41,.06)' },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: { boxShadow: '0 6px 18px rgba(2,14,41,.08)' },
            },
        },
    },
});

}

export default createDomainTheme();